import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { EventsListComponent } from './events-list.component';
import { EventsDetailComponent } from './events-detail.component';

import { EventsRoutingModule } from './events-routing.module';

import { EventFeatureService } from '../services/event-feature.service';
import { EventService } from '../services/event.service';
import { UserService } from '../services/user.service';

@NgModule({
  imports: [
    CommonModule,
    EventsRoutingModule,
    FormsModule
  ],
  declarations: [
    EventsListComponent,
    EventsDetailComponent,
  ],
  providers: [
    EventFeatureService,
    EventService,
    UserService,
  ],
})
export class EventsModule { }



// WEBPACK FOOTER //
// D:/ThinkBIT/work-projects/confe/hosting/src/app/events/events.module.ts